<div class="tidy-input-field" (click)="focusNativeInput()">
  @if (label) {
    <tidy-text
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!disableElement && !form?.valid && submitted" />
  }

  <div
    class="input-container"
    [class.invalid-field]="!disableElement && !form?.valid && submitted"
    [class.no-border]="noBorder"
    [class.focused]="focused"
    [class.has-action]="action">
    @if (icon) {
      <tidy-image [src]="icon" class="input-icon no-right-margin" />
    }

    @if (!inputMask || !inputMask.mask) {
      <input
        [id]="inputId"
        #neurotypicalInput
        (keydown)="changeTouch()"
        (keyup)="keyUpHandle($event)"
        [(ngModel)]="value"
        [type]="type"
        [disabled]="disableElement"
        [attr.inputMode]="inputMode"
        [attr.maxlength]="inputMask?.maxLenghth"
        (focus)="setFocused(true)"
        (focusout)="setFocused(false)"
        [autocomplete]="autoComplete"
        [placeholder]="placeholder || helperText || '' | translate"
        />
    }

    @if (inputMask && inputMask.mask) {
      <input
        [attr.maxlength]="inputMask.maxLenghth"
        [imask]="inputMask"
        [unmask]="unmask"
        #maskedInput
        [disabled]="disableElement"
        [class.offset-content]="inputMask?.additionalCharacter && !isInputEmpty"
        (keydown)="changeTouch()"
        [(ngModel)]="value"
        (keyup)="keyUpHandle($event)"
        [type]="type"
        [attr.inputMode]="inputMode"
        (focus)="setFocused(true)"
        (focusout)="setFocused(false)"
        [autocomplete]="autoComplete"
        [placeholder]="placeholder || helperText || '' | translate"
        />
    }

    @if (inputMask?.additionalCharacter && !isInputEmpty) {
      <span class="additional-character">
        {{ inputMask?.additionalCharacter }}
      </span>
    }

    @if (textSuffix) {
      <span class="text-suffix">
        {{ textSuffix }}
      </span>
    }

    @if (type === 'number' && !action) {
      <div class="number-arrows">
        <button type="button" class="number-arrow-btn up" (click)="incrementValue($event)" [disabled]="disableElement">
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
            <path d="M5 6.5L8 4L11 6.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button type="button" class="number-arrow-btn down" (click)="decrementValue($event)" [disabled]="disableElement">
          <svg width="16" height="10" viewBox="0 0 16 10" fill="none">
            <path d="M5 3.5L8 6L11 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    }

    @if (action) {
      <button
        class="action-button"
        [ngClass]="{ empty: isInputEmpty }"
        [disabled]="loadingState.loading || isInputEmpty"
        (click)="executeAction()">
        <mat-icon [ngClass]="{ 'default-icon': !buttonIcon }" [style.color]="buttonIconColor">{{ buttonIcon }}</mat-icon>
      </button>
    }
  </div>

  @if (!disableElement && !form?.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
</div>
